"use strict";var _router=_interopRequireDefault(require("@/router"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}/* eslint-disable */var _default={/**
   * @var {AxiosInstance} $http
   */get $http(){return _router.default.app.$http},/**
   * Get the collection of resources.
   *
   * @param {string} url
   * @param {array} params
   * @returns {Observable<any>}
   */getData(a){let b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{},c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{};return this.$http[c.postOnIndex?"post":"get"](a,b)},/**
   * Get a single resource
   *
   * @param {string} url
   * @param {number} id
   * @param {object} params
   * @returns {Observable<any>}
   */getItem(a,b){let c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{};return this.$http.get(`${a}/${b}`,c)},/**
   * Create a new resource
   *
   * @param {string} url
   * @param {object} data
   * @param {object} params
   * @returns {Observable<any>}
   */saveItem(a,b){let c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{};return this.$http.post(a,b,c)},/**
   * Update an existing resource
   *
   * @param {string} url
   * @param {number} id
   * @param {object} data
   * @param {object} params
   * @returns {Observable<any>}
   */updateItem(a,b,c){let d=3<arguments.length&&arguments[3]!==void 0?arguments[3]:{};return this.$http.put(`${a}/${b}`,c,d)},/**
   * Delete an existing resource
   *
   * @param {string} url
   * @param {number} id
   * @returns {Observable<any>}
   */deleteItem(a,b){return this.$http.delete(`${a}/${b}`)}};exports.default=_default;


// WEBPACK FOOTER //
// ./node_modules/@fps/vue-toolkit/dist/services/api.service.js